import TenantRemoveManyButton, {
  type TenantRemoveManyButtonProps,
} from "@/v2-backoffice-client/tenant/remove/many/TenantRemoveManyButton"
import TenantRestoreManyButton, {
  type TenantRestoreManyButtonProps,
} from "@/v2-backoffice-client/tenant/restore/many/TenantRestoreManyButton"

export type TenantRemoveOrRestoreManyButtonProps = TenantRemoveManyButtonProps &
  TenantRestoreManyButtonProps & {
    isDeleted: boolean
  }

function TenantRemoveOrRestoreManyButton(
  props: TenantRemoveOrRestoreManyButtonProps,
) {
  const { isDeleted, ...buttonProps } = props
  if (isDeleted) {
    return <TenantRestoreManyButton {...buttonProps} />
  }
  return <TenantRemoveManyButton {...buttonProps} />
}

export default TenantRemoveOrRestoreManyButton
